import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Component, useEffect } from 'react';

import { defineMessages, injectIntl, useIntl } from 'react-intl';

import { Link } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';

import AccountCircleIcon from '@/material-icons/400-24px/account_circle.svg?react';
import AddIcon from '@/material-icons/400-24px/add.svg?react';
import AlternateEmailIcon from '@/material-icons/400-24px/mail.svg?react';
import BookmarksActiveIcon from '@/material-icons/400-24px/bookmarks-fill.svg?react';
import BookmarksIcon from '@/material-icons/400-24px/bookmarks.svg?react';
import ExploreActiveIcon from '@/material-icons/400-24px/explore-fill.svg?react';
import ExploreIcon from '@/material-icons/400-24px/explore.svg?react';
import ModerationIcon from '@/material-icons/400-24px/gavel.svg?react';
import HomeActiveIcon from '@/material-icons/400-24px/home-fill.svg?react';
import HomeIcon from '@/material-icons/400-24px/home.svg?react';
import ListAltActiveIcon from '@/material-icons/400-24px/list_alt-fill.svg?react';
import ListAltIcon from '@/material-icons/400-24px/list_alt.svg?react';
import AdministrationIcon from '@/material-icons/400-24px/manufacturing.svg?react';
import NotificationsActiveIcon from '@/material-icons/400-24px/notifications-fill.svg?react';
import NotificationsIcon from '@/material-icons/400-24px/notifications.svg?react';
import ScheduledStatusesIcon from '@/styles/bird-theme-svg/calendar-clock.svg?react';
import FollowRequestsActiveIcon from '@/styles/bird-theme-svg/user-add-fill.svg?react';
import FollowRequestsIcon from '@/styles/bird-theme-svg/user-add.svg?react';
import PendingMentionsActiveIcon from '@/styles/bird-theme-svg/messages-fill.svg?react';
import MailIcon from '@/material-icons/400-24px/mail.svg?react';
import PendingMentionsIcon from '@/styles/bird-theme-svg/messages.svg?react';
import PublicIcon from '@/material-icons/400-24px/public.svg?react';
import SearchIcon from '@/material-icons/400-24px/search.svg?react';
import SettingsIcon from '@/material-icons/400-24px/settings.svg?react';
import { fetchFollowRequests } from 'mastodon/actions/accounts';
import { fetchDmRooms } from 'mastodon/actions/dm_rooms';
import { Icon } from 'mastodon/components/icon';
import { IconWithBadge } from 'mastodon/components/icon_with_badge';
import { WordmarkLogo } from 'mastodon/components/logo';
import { NavigationPortal } from 'mastodon/components/navigation_portal';
import { identityContextPropShape, withIdentity } from 'mastodon/identity_context';
import { timelinePreview, trendsEnabled, dmChatEnabled } from 'mastodon/initial_state';
import { canManageDirectMessages } from 'mastodon/permissions';
import { selectUnreadDmCount } from 'mastodon/features/messages/selectors';
import { selectUnreadNotificationGroupsCount } from 'mastodon/selectors/notifications';

import { AccountSwitcher } from './account_switcher';
import ColumnLink from './column_link';
import { Search } from 'mastodon/features/compose/components/search';
import { useBreakpoint } from 'mastodon/hooks/useBreakpoint';
import { closeNavigation } from 'mastodon/actions/navigation';
import { connect } from 'react-redux';
import { Avatar } from 'mastodon/components/avatar';
import { me } from 'mastodon/initial_state';

// @_longwhile — 운영진의 "모든 채팅" 아이콘.
//   답장할 멘션과 **같은 그림**을 쓴다. 같은 파일을 두 번 import 하면 중복
//   import 로 잡히므로 별칭만 둔다.
//   두 항목이 한 내비에 나란히 서면 그림이 겹친다 — 운영진에게만 보이는 항목이라
//   당장은 헷갈릴 자리가 좁지만, 서로 다른 그림을 쓰는 편이 낫다.
const MessagesAllIcon = PendingMentionsIcon;
const MessagesAllActiveIcon = PendingMentionsActiveIcon;

// @_longwhile — 채팅 두 항목의 활성 판정.
//
//   상류의 `exact` 로는 `/messages/3` 에서 "채팅" 이 꺼진다. 그렇다고 접두사
//   일치로 두면 `/messages/all/3` 에서 **둘 다** 켜진다 — 두 항목이 경로를
//   나눠 갖고 있기 때문이다. 그래서 판정을 여기서 직접 적는다.
//
//     /messages          채팅
//     /messages/3        채팅
//     /messages/all      모든 채팅
//     /messages/all/3    모든 채팅
//
//   `/messages/all` 로 시작하는지를 먼저 본다. 순서를 뒤집으면 "채팅" 이 운영진
//   화면까지 가져간다.
//   시그니처는 react-router 의 것이다 — `(match, location)`. NavLink 는 경로가
//   맞지 않아도 이 함수를 부르므로(`match` 가 null 인 채로) `location` 만 본다.
const isAllMessagesPathname = (pathname) =>
  pathname === '/messages/all' || pathname.startsWith('/messages/all/');

const isMessagesAllPath = (_match, location) =>
  isAllMessagesPathname(location.pathname);

const isMessagesPath = (_match, location) =>
  !isAllMessagesPathname(location.pathname) &&
  (location.pathname === '/messages' ||
    location.pathname.startsWith('/messages/'));

const messages = defineMessages({
  home: { id: 'tabs_bar.home', defaultMessage: 'Home' },
  notifications: { id: 'tabs_bar.notifications', defaultMessage: 'Notifications' },
  explore: { id: 'explore.title', defaultMessage: 'Explore' },
  firehose: { id: 'column.firehose', defaultMessage: 'Live feeds' },
  direct: { id: 'navigation_bar.direct', defaultMessage: 'Private mentions' },
  pendingMentions: { id: 'navigation_bar.pending-mentions', defaultMessage: 'Awaiting reply' },
  messages: { id: 'navigation_bar.messages', defaultMessage: 'Messages' },
  messagesAll: { id: 'navigation_bar.messages_all', defaultMessage: 'All messages' },
  bookmarks: { id: 'navigation_bar.bookmarks', defaultMessage: 'Bookmarks' },
  scheduledStatuses: { id: 'navigation_bar.scheduled_statuses', defaultMessage: 'Scheduled posts' },
  scheduledStatusesFailed: { id: 'navigation_bar.scheduled_statuses_failed', defaultMessage: 'Scheduled posts (failed)' },
  lists: { id: 'navigation_bar.lists', defaultMessage: 'Lists' },
  preferences: { id: 'navigation_bar.preferences', defaultMessage: 'Preferences' },
  administration: { id: 'navigation_bar.administration', defaultMessage: 'Administration' },
  moderation: { id: 'navigation_bar.moderation', defaultMessage: 'Moderation' },
  followsAndFollowers: { id: 'navigation_bar.follows_and_followers', defaultMessage: 'Follows and followers' },
  search: { id: 'navigation_bar.search', defaultMessage: 'Search' },
  followRequests: { id: 'navigation_bar.follow_requests', defaultMessage: 'Follow requests' },
  compose: { id: 'navigation_panel.compose', defaultMessage: 'New Post' },
  accountSwitch: { id: 'navigation_panel.account_switch', defaultMessage: 'Switch accounts' },
});

const ProfileSummary = connect((state) => {
  const accounts = typeof state?.getIn === 'function' ? state.getIn(['accounts']) : state?.accounts ?? null;
  const account = (() => {
    if (!accounts || !me) return null;
    if (typeof accounts.get === 'function') return accounts.get(me);
    return accounts[me] ?? null;
  })();
  return { account };
})(({ account, avatarSize = 48 }) => {
  if (!account) {
    return null;
  }

  const getValue = (key) => (typeof account.get === 'function' ? account.get(key) : account[key]);

  const acct = getValue('acct');
  const displayName = getValue('display_name_html') || getValue('display_name') || getValue('username');

  return (
    <Link to={`/@${acct}`} className='navigation-panel__profile-card' title={acct}>
      <div className='navigation-panel__profile-avatar'>
        <Avatar account={account} size={avatarSize} />
      </div>
      <div className='navigation-panel__profile-meta'>
        <strong
          className='navigation-panel__profile-name'
          dangerouslySetInnerHTML={{ __html: displayName }}
        />
        <span className='navigation-panel__profile-handle'>@{acct}</span>
      </div>
    </Link>
  );
});

const ProfileSection = ({ avatarSize }) => (
  <div className='navigation-panel__profile'>
    <ProfileSummary avatarSize={avatarSize} />
  </div>
);
ProfileSection.propTypes = {
  avatarSize: PropTypes.number,
};

const AccountSwitcherMenuItem = () => {
  const intl = useIntl();
  const label = intl.formatMessage(messages.accountSwitch);

  return (
    <AccountSwitcher
      renderTrigger={({ openManage }) => (
        <button
          type='button'
          className='column-link column-link--transparent navigation-panel__account-switch-link'
          onClick={openManage}
        >
          <Icon id='account-circle' icon={AccountCircleIcon} className='column-link__icon' />
          <span>{label}</span>
        </button>
      )}
    />
  );
};

const NotificationsLink = () => {

  const count = useSelector(selectUnreadNotificationGroupsCount);
  const intl = useIntl();
  const label = intl.formatMessage(messages.notifications);

  return (
    <ColumnLink
      key='notifications'
      transparent
      to='/notifications'
      icon={<IconWithBadge id='bell' icon={NotificationsIcon} count={count} className='column-link__icon' />}
      activeIcon={<IconWithBadge id='bell' icon={NotificationsActiveIcon} count={count} className='column-link__icon' />}
      text={label}
    />
  );
};

// ─── @_longwhile — 안 읽은 DM 배지 ───
//   알림과 같은 모양으로 안 읽은 **메시지 수**를 띄운다. 방 수가 아니라 메시지
//   수인 이유는 목록 카드가 방마다 같은 기준으로 숫자를 보이기 때문이다 — 두
//   숫자가 다른 것을 세면 배지와 목록이 어긋나 보인다.
//
//   **항목 자체는 늘 보인다.** 팔로우 요청과 다르다. 그쪽은 승인제를 안 쓰면
//   평생 0 이라 감췄지만, 메시지는 배지가 0 이어도 들어갈 일이 있는 화면이다.
//
//   개수는 목록에서 센다. 서버가 총합만 주는 API 가 따로 없고, 어차피 눌러
//   들어가면 같은 목록을 쓴다. 새 DM 이 오면 user 스트림의 `conversation` 이
//   dmChatStreamUpdate 를 깨워 목록을 다시 읽으므로(actions/streaming.js) 새로
//   고치지 않아도 배지가 는다. 읽으면 markDmRoomRead 응답이 그 방의 unread_count
//   를 0 으로 만들어 배지가 준다.
//
//   아이콘은 테마 SCSS 가 mask-image 로 갈아 끼운다(.icon-messages →
//   bird-theme-svg/envelope). IconWithBadge 가 감싸도 `.icon-messages` 는 그대로
//   붙으므로 알림(.icon-bell)과 같은 방식으로 동작한다.
const MessagesLink = () => {
  const dispatch = useDispatch();
  const count = useSelector(selectUnreadDmCount);
  const intl = useIntl();
  const label = intl.formatMessage(messages.messages);

  // **인자 없이 부르지 않는다.** createAsyncThunk 는 넘긴 것을 그대로 `meta.arg`
  // 로 싣는데, 아무것도 안 넘기면 그것이 `undefined` 가 된다. fulfilled 리듀서가
  // 거기서 `meta.arg.refresh` 를 읽으므로 **리듀서가 통째로 터지고**, 상태가
  // pending 인 채로 남아 목록이 비고 배지가 0 이 된다.
  //
  // 새로고침하면 배지가 사라지던 것이 이것이다. 스트림이 부르는 쪽은
  // `{ refresh: true }` 를 넘겨서 멀쩡했고, 그래서 **DM 이 새로 와야만 배지가
  // 살아나는** 모양이 됐다.
  useEffect(() => {
    dispatch(fetchDmRooms({}));
  }, [dispatch]);

  return (
    <ColumnLink
      key='messages'
      transparent
      to='/messages'
      isActive={isMessagesPath}
      icon={<IconWithBadge id='messages' icon={MailIcon} count={count} className='column-link__icon' />}
      text={label}
    />
  );
};

// ─── @_longwhile — 들어온 팔로우 요청 ───
//   **요청이 하나라도 있을 때만 나타난다.** 승인제를 쓰지 않는 사용자에게는
//   평생 0 인 항목이라, 늘 띄워두면 자리만 차지한다.
//
//   개수는 목록에서 센다. 서버가 개수만 주는 API 가 따로 없고, 어차피 눌러
//   들어가면 같은 목록을 쓴다. 새 요청은 알림 스트림을 타고 리듀서가 목록 앞에
//   끼워 넣으므로(reducers/user_lists.js), 새로고침하지 않아도 배지가 는다.
const FollowRequestsLink = () => {
  const dispatch = useDispatch();
  const count = useSelector(state => state.getIn(['user_lists', 'follow_requests', 'items'])?.size ?? 0);
  const intl = useIntl();

  useEffect(() => {
    dispatch(fetchFollowRequests());
  }, [dispatch]);

  if (count < 1) {
    return null;
  }

  return (
    <ColumnLink
      key='follow_requests'
      transparent
      to='/follow_requests'
      icon={<IconWithBadge id='follow-requests' icon={FollowRequestsIcon} count={count} className='column-link__icon' />}
      activeIcon={<IconWithBadge id='follow-requests' icon={FollowRequestsActiveIcon} count={count} className='column-link__icon' />}
      text={intl.formatMessage(messages.followRequests)}
    />
  );
};

// No pending count: a queue that is simply waiting is not something the user has
// to act on. A failed publication still raises the red issue dot — without it, a
// post that never went out would be silently invisible.
const ScheduledStatusesLink = () => {
  const failed = useSelector(state => state.getIn(['scheduled_statuses', 'usage', 'failed'], 0));
  const intl = useIntl();
  const label = intl.formatMessage(failed > 0 ? messages.scheduledStatusesFailed : messages.scheduledStatuses);

  return (
    <ColumnLink
      key='scheduled_statuses'
      transparent
      to='/scheduled_statuses'
      icon={<IconWithBadge id='clock-o' icon={ScheduledStatusesIcon} count={0} issueBadge={failed > 0} className='column-link__icon' />}
      text={label}
    />
  );
};

class NavigationPanel extends Component {
  static propTypes = {
    identity: identityContextPropShape,
    intl: PropTypes.object.isRequired,
    renderSearch: PropTypes.bool,
    renderComposeButton: PropTypes.bool,
    isBelowFullBreakpoint: PropTypes.bool,
    isMobileBreakpoint: PropTypes.bool,
  };

  static defaultProps = {
    renderSearch: false,
    renderComposeButton: false,
    isBelowFullBreakpoint: false,
    isMobileBreakpoint: false,
  };

  isFirehoseActive = (match, location) => {
    return match || location.pathname.startsWith('/public');
  };

  render() {
    const { intl, isBelowFullBreakpoint, isMobileBreakpoint } = this.props;
    const { signedIn } = this.props.identity;

    const renderSearch = this.props.renderSearch ?? false;
    const renderComposeButton = this.props.renderComposeButton ?? false;
    const isFullView = !isBelowFullBreakpoint;
    const showIdentitySection = signedIn && !isFullView;
    const profileAvatarSize = isFullView ? 48 : 36;

    const panelClassName = classNames('navigation-panel', {
      'navigation-panel--full': isFullView,
      'navigation-panel--compact': !isFullView,
      'navigation-panel--mobile': isMobileBreakpoint,
    });

    return (
      <div className={panelClassName}>
        <div className='navigation-panel__logo'>
          <Link to='/' className='column-link column-link--logo'><WordmarkLogo /></Link>
        </div>

        {renderSearch && (
          <div className='navigation-panel__search'>
            <Search openInRoute singleColumn />
          </div>
        )}

        {showIdentitySection && <ProfileSection avatarSize={profileAvatarSize} />}

        {renderComposeButton && signedIn && (
          <Link to='/publish' className='button button--block navigation-panel__compose-button'>
            <Icon
              id='add'
              icon={AddIcon}
              className='navigation-panel__compose-button-icon'
              aria-hidden
            />
            <span>{intl.formatMessage(messages.compose)}</span>
          </Link>
        )}

        <div className='navigation-panel__menu'>
          {signedIn && (
            <>
              {this.renderSignedInLinks(intl, true)}
            </>
          )}

          {!signedIn && trendsEnabled ? (
            <ColumnLink transparent to='/explore' icon='explore' iconComponent={ExploreIcon} activeIconComponent={ExploreActiveIcon} text={intl.formatMessage(messages.explore)} />
          ) : null}

          {!signedIn && !trendsEnabled ? (
            <ColumnLink transparent to='/search' icon='search' iconComponent={SearchIcon} text={intl.formatMessage(messages.search)} />
          ) : null}

        </div>

        <NavigationPortal />
      </div>
    );
  }
  renderSignedInLinks = (intl, includeAccountSwitcher = true) => {
    const { permissions } = this.props.identity;

    const homeLabel = intl.formatMessage(messages.home);
    const publicLabel = intl.formatMessage(messages.firehose);
    const directLabel = intl.formatMessage(messages.direct);
    const pendingMentionsLabel = intl.formatMessage(messages.pendingMentions);
    const bookmarksLabel = intl.formatMessage(messages.bookmarks);
    const preferencesLabel = intl.formatMessage(messages.preferences);
    const listsLabel = intl.formatMessage(messages.lists);

    const origin =
      typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : '';
    const settingsHref = `${origin}/settings/profile`;

    return (
      <>
        <ColumnLink transparent to='/home' icon='home' iconComponent={HomeIcon} activeIconComponent={HomeActiveIcon} text={homeLabel} />
        <ColumnLink transparent to='/public' isActive={this.isFirehoseActive} icon='globe' iconComponent={PublicIcon} text={publicLabel} />
        <NotificationsLink />
        <ColumnLink transparent to='/pending-mentions' icon='pending' iconComponent={PendingMentionsIcon} activeIconComponent={PendingMentionsActiveIcon} text={pendingMentionsLabel} />
        {/* @_longwhile — 채팅과 기존 다이렉트 타임라인을 최상위에 함께 두지 않는다.
            둘 다 있으면 사용자가 차이를 알 수 없다. 채팅이 켜져 있으면 그것만
            내비에 두고, 기존 화면은 /conversations 로 여전히 열린다 —
            3인 이상 대화가 그리로 떨어지므로 경로 자체는 살아 있어야 한다.
            (기획서 오픈 이슈 OI-10)

            아이콘은 테마 SCSS 가 mask-image 로 갈아 끼운다
            (.icon-messages → bird-theme-svg/envelope). 아래의 MailIcon 은
            테마를 쓰지 않는 기본 화면용 원본이다. */}
        {dmChatEnabled ? (
          <MessagesLink />
        ) : (
          <ColumnLink transparent to='/conversations' icon='at' iconComponent={AlternateEmailIcon} text={directLabel} />
        )}
        {/* @_longwhile — 운영진의 DM 전체 열람. 판정은 서버의
            Admin::DirectMessagePolicy(`administrator` 또는 `manage_roles`)와 같게
            맞춘다. 여기서 감추는 것은 편의일 뿐이고, 진짜 방어선은 API 쪽이다. */}
        {dmChatEnabled && canManageDirectMessages(permissions) && (
          <ColumnLink transparent to='/messages/all' isActive={isMessagesAllPath} icon='messages-all' iconComponent={MessagesAllIcon} activeIconComponent={MessagesAllActiveIcon} text={intl.formatMessage(messages.messagesAll)} />
        )}
        <ScheduledStatusesLink />
        <ColumnLink transparent to='/bookmarks' icon='bookmarks' iconComponent={BookmarksIcon} activeIconComponent={BookmarksActiveIcon} text={bookmarksLabel} />
        <ColumnLink transparent to='/lists' icon='list-ul' iconComponent={ListAltIcon} activeIconComponent={ListAltActiveIcon} text={listsLabel} />
        <ColumnLink transparent href={settingsHref} icon='cog' iconComponent={SettingsIcon} text={preferencesLabel} />
        {/* 계정 전환 **위**. 요청이 없으면 아무것도 그리지 않는다.
            실제 순서는 테마 SCSS 의 `order` 가 정하므로(CLAUDE.md 맨 앞의 함정)
            네 파일에서 팔로우 요청 12 / 계정 전환 13 으로 함께 바꿨다. 여기
            순서는 DOM 순서일 뿐이지만, 둘이 어긋나 있으면 다음 사람이 JSX 만
            보고 잘못 읽는다. */}
        <FollowRequestsLink />
        {includeAccountSwitcher && <AccountSwitcherMenuItem />}
      </>
    );
  };
}

const NavigationPanelWithIdentity = injectIntl(withIdentity(NavigationPanel));

const NavigationPanelWithBreakpoints = (props) => {
  const isBelowFullBreakpoint = useBreakpoint('full');
  const isMobileBreakpoint = useBreakpoint('openable');
  return (
    <NavigationPanelWithIdentity
      {...props}
      isBelowFullBreakpoint={isBelowFullBreakpoint}
      isMobileBreakpoint={isMobileBreakpoint}
    />
  );
};

export default NavigationPanelWithBreakpoints;

export const CollapsibleNavigationPanel = () => {
  const dispatch = useDispatch();
  const navigationOpen = useSelector(state => state.getIn(['navigation', 'open'], false));
  const isMobile = useBreakpoint('openable');
  const showSearch = true;
  const shouldShowOverlay = isMobile && navigationOpen;

  useEffect(() => {
    if (!navigationOpen) {
      return undefined;
    }

    const handleKeyUp = (event) => {
      if (event.key === 'Escape') {
        dispatch(closeNavigation());
      }
    };

    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [navigationOpen, dispatch]);

  useEffect(() => {
    if (!isMobile && navigationOpen) {
      dispatch(closeNavigation());
    }
  }, [isMobile, navigationOpen, dispatch]);

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      dispatch(closeNavigation());
    }
  };

  const containerClassName = classNames('navigation-panel__container', {
    'navigation-panel__container--overlay': shouldShowOverlay,
  });

  const wrapperClassName = classNames('navigation-panel__wrapper', {
    'navigation-panel__wrapper--open': !isMobile || navigationOpen,
  });

  return (
    <div
      className={containerClassName}
      onClick={shouldShowOverlay ? handleOverlayClick : undefined}
    >
      <div className={wrapperClassName}>
        <NavigationPanelWithBreakpoints
          renderSearch={showSearch}
          renderComposeButton
        />
      </div>
    </div>
  );
};
